var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecConfig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 38.5C77 59.763 59.763 77 38.5 77C17.237 77 0 59.763 0 38.5C0 17.237 17.237 0 38.5 0C59.763 0 77 17.237 77 38.5Z",
    fill: "#FDC5C5",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.125 32.125H53.875C54.3723 32.125 54.8492 32.3225 55.2008 32.6742C55.5525 33.0258 55.75 33.5027 55.75 34V56.5C55.75 56.9973 55.5525 57.4742 55.2008 57.8258C54.8492 58.1775 54.3723 58.375 53.875 58.375H23.875C23.3777 58.375 22.9008 58.1775 22.5492 57.8258C22.1975 57.4742 22 56.9973 22 56.5V34C22 33.5027 22.1975 33.0258 22.5492 32.6742C22.9008 32.3225 23.3777 32.125 23.875 32.125H27.625V30.25C27.625 27.2663 28.8103 24.4048 30.92 22.295C33.0298 20.1853 35.8913 19 38.875 19C41.8587 19 44.7202 20.1853 46.83 22.295C48.9397 24.4048 50.125 27.2663 50.125 30.25V32.125ZM25.75 35.875V54.625H52V35.875H25.75ZM37 43.375H40.75V47.125H37V43.375ZM29.5 43.375H33.25V47.125H29.5V43.375ZM44.5 43.375H48.25V47.125H44.5V43.375ZM46.375 32.125V30.25C46.375 28.2609 45.5848 26.3532 44.1783 24.9467C42.7718 23.5402 40.8641 22.75 38.875 22.75C36.8859 22.75 34.9782 23.5402 33.5717 24.9467C32.1652 26.3532 31.375 28.2609 31.375 30.25V32.125H46.375Z",
    fill: "#CF2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecConfig);
export default __webpack_public_path__ + "static/media/SecConfig.b5ad7aeb37a67f44523c856032f8091c.svg";
export { ForwardRef as ReactComponent };